<template>
    <div class="page-wirtschaftlichkeit">
        <div class="col-md-3 col-lg-2 d-md-block bg-light sidebar">
            <NavPlantsSidebar v-if="plantsLoaded" v-bind="currentPlantsProperties"
                v-on:setPlant="setEconomicPlant"></NavPlantsSidebar>
        </div>
        <div class="col-md-9 ms-sm-auto col-lg-10">
            <template v-if="this.currentPlant">
                <div class="container-fluid my-3">
                    <h4>{{ $t("wirtschaftlichkeit") }} - {{ currentPlant.name }}</h4>

                    <template v-if="configExists">
                        <EconomicReport
                            :plant="currentPlant"
                            :economicConfig="economicConfig"
                        ></EconomicReport>
                    </template>
                    <template v-else>
                        <div class="alert alert-info">
                            <i class="fa-solid fa-info-circle"></i>
                            {{ $t("economic_config_not_exists") }}
                            <router-link to="/settings/wirtschaftlichkeit" class="alert-link">
                                {{ $t("go_to_config") }}
                            </router-link>
                        </div>
                    </template>
                </div>
            </template>
            <template v-else>
                <div class="card mt-3">
                    <div class="card-body">
                        <p class="text-muted">{{ $t("select_plant_for_economic") }}</p>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import EconomicReport from '@/components/wirtschaftlichkeit/EconomicReport.vue'
import NavPlantsSidebar from '@/components/navs/NavPlantsSidebar.vue'
import apiClient from '@/services/apiClient'

export default {
    name: 'Wirtschaftlichkeit',
    components: {
        EconomicReport,
        NavPlantsSidebar
    },
    data() {
        return {
            currentPlant: null,
            economicConfig: null,
            loading: false
        }
    },
    watch: {
        currentPlant: {
            handler(newVal) {
                if (newVal && newVal.id) {
                    this.loadEconomicConfig()
                }
            },
            immediate: true
        }
    },
    methods: {
        setEconomicPlant(plant) {
            this.currentPlant = plant
        },
        async loadEconomicConfig() {
            this.loading = true
            try {
                const response = await apiClient.getEconomicConfigForPlant(this.currentPlant.id)
                this.economicConfig = response.data
            } catch (error) {
                console.error('Error loading economic config:', error)
                this.economicConfig = {
                    exists: false
                }
            } finally {
                this.loading = false
            }
        }
    },
    computed: {
        plantsLoaded() {
            return !!this.$store.getters.getPlants
        },
        configExists() {
            return this.economicConfig && this.economicConfig.exists
        },
        currentPlantsProperties() {
            return {
                plants: this.$store.getters.getPlants,
                showPlantComponents: false,
                editPlantComponents: false,
                editPlants: false
            }
        }
    }
}
</script>
